<template>
	<div class="page3warp">
		<div class="institutionalbox" v-if="contentObj">
			
				<div v-html="contentObj" class="img"></div>
		
			<!-- <img src="@/assets/imgs/aboutus/institutional.png" /> -->
		</div>
	</div>
</template>
<script>
import { httpService, srcUrl } from "@/service/httpService";
export default {
	data() {
		return {
			srcUrl: srcUrl,
			currentPage: 1,
			pageSize: 100,
			contentObj: null

		}
	},
	mounted() {
		this.getNewsData()
	},
	methods: {
		async getNewsData() {
			let params = {
				pageSize: this.pageSize,
				pageCurrent: this.currentPage,
				pressSuperClass: 105,
			};
			let data = await httpService.getHeadList(params);
			if (data.code == 200) {
				if (data.result.list.length != 0) {
					this.contentObj = data.result.list[0]
				}
			}
		},
	}
}
</script>
<style lang="less" scoped>
.page3warp {
	width: 1200px;
	.institutionalbox {
		margin-top: 46px;
		width: 100%;
		text-align: center;
		/deep/img{
			width: 1200px;
		}
		.img{
			width: 1200px;
		}
		img{
			width: 1200px;
		}
	}
}
</style>


